import Pagination from './Pagination';

export type { PaginationConfig, PaginationProps } from './Pagination';
export default Pagination;
